import { render, staticRenderFns } from "./ModalApproval.vue?vue&type=template&id=8be822dc&"
import script from "./ModalApproval.vue?vue&type=script&lang=js&"
export * from "./ModalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports